import axios from 'axios';
import AppEnv from '../constants/AppEnv';

class axiosApi {
    static get(endpoint, useGateway, params, withCredentials = false) {
        let url = AppEnv.baseApiUrl + "/" + endpoint;
        let config = {
            headers: null,
            params: params,
            withCredentials: withCredentials
        };

        if (useGateway) {
            url = digitalData.microServiceInfo.Gateway.uri + "/" + endpoint;
            config = {
                headers: { "Authorization": digitalData.microServiceInfo.Gateway.token },
                params: params
            };
            if (document.documentMode) {  //Prevent IE from caching the response and not making subsequent requests
                config.headers.Pragma = 'no-cache';
            }
            let nowUtc = Date.now();
            let isGatewayTokenExpired = (digitalData.microServiceInfo.Gateway.expirationUtc < nowUtc);
            if (isGatewayTokenExpired) {
                return axios.get(AppEnv.baseApiUrl + "/MicroServiceInfo").then(response => {
                    digitalData.microServiceInfo.Gateway = response.data.gateway;

                    url = digitalData.microServiceInfo.Gateway.uri + "/" + endpoint;
                    config = {
                        headers: { "Authorization": digitalData.microServiceInfo.Gateway.token },
                        params: params
                    };
                    if (document.documentMode) {  //Prevent IE from caching the response and not making subsequent requests
                        config.headers.Pragma = 'no-cache';
                    }
                    return this.getEndpoint(url, config);
                });
            }
            else {
                return this.getEndpoint(url, config);
            }
        }
        else {
            return this.getEndpoint(url, config);
        }
    }
    static post(endpoint, useGateway, data, withCredentials = false) {
        let url = AppEnv.baseApiUrl + "/" + endpoint;
        let config = {
            headers: null,
            withCredentials: withCredentials
        };

        if (useGateway) {
            url = digitalData.microServiceInfo.Gateway.uri + "/" + endpoint;
            config = { headers: { "Authorization": digitalData.microServiceInfo.Gateway.token } };

            let nowUtc = Date.now();
            let isGatewayTokenExpired = (digitalData.microServiceInfo.Gateway.expirationUtc < nowUtc);
            if (isGatewayTokenExpired) {
                return axios.get(AppEnv.baseApiUrl + "/MicroServiceInfo").then(response => {
                    digitalData.microServiceInfo.Gateway = response.data.gateway;

                    url = digitalData.microServiceInfo.Gateway.uri + "/" + endpoint;
                    config = { headers: { "Authorization": digitalData.microServiceInfo.Gateway.token } };
                    return this.postEndpoint(url, data, config);
                });
            }
            else {
                return this.postEndpoint(url, data, config);
            }
        }
        else {
            return this.postEndpoint(url, data, config);
        }
    }
    static getEndpoint(url, config) {
        return axios.get(url, config).then(response => {
            return response.data;
        }).catch(error => {
            throw error;
        });
    }
    static postEndpoint(url, data, config) {
        return axios.post(url, data, config).then(response => {
            return response.data;
        }).catch(error => {
            throw error;
        });
    }
}

export default axiosApi;  